import { render, staticRenderFns } from "./Handover.vue?vue&type=template&id=4046881e&scoped=true&"
import script from "./Handover.vue?vue&type=script&lang=js&"
export * from "./Handover.vue?vue&type=script&lang=js&"
import style0 from "./Handover.vue?vue&type=style&index=0&id=4046881e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046881e",
  null
  
)

export default component.exports